__webpack_require__.p = "https://vodafone.uat.billing.affinity.io/";